import { Button } from "@ui/Button";
import { deleteClips } from "@/client";
import { useBoards } from "~/modules/shared/boards/boardsContext";

type Props = {
	boardId: string;
	clipId: string;
	onClose: () => void;
};

export const RemoveFromBoardButton = (props: Props) => {
	const boards = useBoards();

	return (
		<Button
			variant="secondary"
			theme="black"
			symbol="bookmark_remove"
			symbolRelativeSize="even-larger"
			onClick={async () => {
				await deleteClips({
					path: {
						board_id: props.boardId,
					},
					body: {
						clip_ids: [props.clipId],
					},
				});
				boards.invalidateClipMembership();
				boards.invalidateBoardsList();
				props.onClose();
			}}
		>
			Remove from board
		</Button>
	);
};
